const digitalFormsBaseUrl = `DigitalForms`;

export const getCancerCareFunds = async (axiosGet, assistanceProgramId) => {
    return await axiosGet(`${digitalFormsBaseUrl}/CancerCareFunds/${assistanceProgramId}`);
}

export const getCancerCareFundMedications = async (axiosGet, assistanceProgramId) => {
    return await axiosGet(`${digitalFormsBaseUrl}/FoundationFundMedications/${assistanceProgramId}`);
}

const cancerCareDependentsSpecialRule = (value, ctx) => {
    const dependentsField = 'Income Number Of Children In Household';
    const field = ctx.getFieldDef(dependentsField);

    if (field && parseInt(value) === 0) {
        ctx.specialRuleChangeData(dependentsField, value, 'Number of dependents must be at least 1. You must include the patient.');
    }
}

const CCEmptyFundIfInsuranceChangesSpecialRule = (value, ctx) => {
    const primaryInsuranceField = 'Insurance Patient Insurance Types CancerCare';
    const field = ctx.getFieldDef(primaryInsuranceField);
    if (field) {
        ctx.specialRuleChangeData('CancerCare Fund Selection', undefined);
    }
}


const cancerCareNoInsuranceSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no insurance') {
        ctx.specialRuleChangeData('Insurance Patient Insurance Types CancerCare', value, 'Patient must be insured to receive co-payment assistance.');
    }
    CCEmptyFundIfInsuranceChangesSpecialRule(value, ctx);
}

export const OnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule = (value, ctx) =>{
    if(!value) return;
    const invalidCharsReg = /[^a-zA-Z\- ]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Patient Name First', 'Patient Name Last', 'Patient Advocate Name First', 'Patient Advocate Name Last', 'Insurance Primary Medical Insurance Name',
    'Insurance Secondary Medical Insurance Name'];
    const checkCharMinimumArr2 = checkCharRestriction;

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
    else{
        const fieldsToCheck2 = GetFieldsToCheck(ctx, value, checkCharMinimumArr2);
        fieldsToCheck2.forEach(field => {
            const fieldValue = ctx.formData[field];
            if (fieldValue.trim().length < 2) {
                const fieldLabel = ctx.getFieldDef(field).label;
                ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 2 characters.`);
            }
        })
    }
}

export const OnlyAlphanumericCharsSpacesHyphensNumberSignsAllowedSpecialRule = (value, ctx) =>{
    if(!value) return;
    const invalidCharsReg = /[^a-zA-Z0-9\- \#]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Patient Address 1', 'Patient Address 2'];
    const checkCharMinimumArr5 = ['Patient Address 1'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove special characters as they are not acceptable in the provider portal.');
        });
    }
    else{
        const fieldsToCheck5 = GetFieldsToCheck(ctx, value, checkCharMinimumArr5);
        fieldsToCheck5.forEach(field => {
            const fieldValue = ctx.formData[field];
            if (fieldValue.trim().length < 5) {
                const fieldLabel = ctx.getFieldDef(field).label;
                ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 5 characters.`);
            }
        })
    }
}


//these are for fields that only need min check no char restriction check
/*export const CCEnforceMinimumCharLength2 = (value, ctx) =>{
    const checkCharMinimumArr2 = [];
    const fieldsToCheck2 = GetFieldsToCheck(ctx, value, checkCharMinimumArr2);
    fieldsToCheck2.forEach(field =>{

        const fieldValue = ctx.formData[field];
        if(fieldValue.trim().length < 2){
            const fieldLabel = ctx.getFieldDef(field).label;
            ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 2 characters.`);
        }
    })
}*/

/*export const CCEnforceMinimumCharLength5 = (value, ctx) =>{
    const checkCharMinimumArr5 = [];
    const fieldsToCheck2 = GetFieldsToCheck(ctx, value, checkCharMinimumArr5);
    fieldsToCheck2.forEach(field =>{

        const fieldValue = ctx.formData[field];
        if(fieldValue.trim().length < 5){
            const fieldLabel = ctx.getFieldDef(field).label;
            ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 5 characters.`);
        }
    })
}*/

function GetFieldsToCheck(ctx, value, arrToCheckAgainst) {
    const formData = Object.keys(ctx.formData).map(function (key) {
        return [key, ctx.formData[key]];
    })
    var arr = [];
    for (var i = 0; i < formData.length; i++) {
        let dataKey = formData[i][0];
        let dataValue = formData[i][1];
        if (dataValue === value) {
            arr.push(dataKey);
        }
    }
    const intersection = arr.filter(element => arrToCheckAgainst.includes(element));
    return intersection;
}

export const createCancerCareRules = (meta, ctx) => {
    ctx.createSpecialRule('Income Number Of Children In Household', cancerCareDependentsSpecialRule);
    cancerCareDependentsSpecialRule(ctx.formData['Income Number Of Children In Household'], ctx);
    ctx.createSpecialRule('Insurance Patient Insurance Types CancerCare', cancerCareNoInsuranceSpecialRule);
    cancerCareNoInsuranceSpecialRule(ctx.formData['Insurance Patient Insurance Types CancerCare'], ctx);

    const alphabeticSpacesHyphensOnlyFields = ['Patient Name First', 'Patient Name Last', 'Patient Advocate Name First', 'Patient Advocate Name Last', 'Insurance Primary Medical Insurance Name',
        'Insurance Secondary Medical Insurance Name']
    alphabeticSpacesHyphensOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, OnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule);
        OnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphanumericSpacesHyphensNumSignOnlyFields = ['Patient Address 1', 'Patient Address 2']
    alphanumericSpacesHyphensNumSignOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, OnlyAlphanumericCharsSpacesHyphensNumberSignsAllowedSpecialRule);
        OnlyAlphanumericCharsSpacesHyphensNumberSignsAllowedSpecialRule(ctx.formData[field], ctx);
    });

}

